import { useCallback, useEffect, useState } from "react";
import _ from "lodash";

import theme from "theme";
import { googleMapsGetStaticMapUrl } from "utils/maps";

import Box from "components/Box";

import LocationTable from "entities/Deal/components/OverviewLocation/LocationTable";
import { IDeal, IMarker } from "entities/Deal/sdk";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

const PrintableSectionLocation = ({
  deal,
  sectionName = "",
  section,
}: {
  deal: IDeal;
  sectionName?: string;
  section?: IMemoSection;
}) => {
  const [markers, setMarkers] = useState<IMarker[]>([]);
  const [mapUrl, setMapUrl] = useState<string>("#");

  useEffect(() => {
    const markers = [
      {
        center: {
          lng: Number(deal.address.longitude),
          lat: Number(deal.address.latitude),
        },
        contentdata: {
          project_name: deal.name,
          address: `${deal.address.street_address}, ${deal.address.city}, ${deal.address.zipcode}`,
          thumbnail: deal.thumbnail,
        },
      },
    ];

    setMarkers(markers);
  }, [deal]);

  const getMapUrl = useCallback(async () => {
    // Convert the image that's behind the url to base64. This way it can be encoded into the HTML.
    const url = googleMapsGetStaticMapUrl({ markers });

    const response = await fetch(url);
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();

    const base64String = btoa(
      String.fromCharCode(...new Uint8Array(arrayBuffer))
    );

    setMapUrl(`data:${blob.type};base64,${base64String}`);
  }, [markers]);

  useEffect(() => {
    if (_.isEmpty(markers)) {
      return;
    }

    getMapUrl();
  }, [markers, getMapUrl]);

  return (
    <Box data-testid="location-section">
      <SectionHeader
        label={section?.title || sectionName}
        alignActionButton={section ? "right" : "left"}
      />
      <SectionContent breakInside="avoid">
        {deal.address && <LocationTable address={deal.address} />}
        <img
          alt="Map"
          id="map-image"
          key={mapUrl}
          src={mapUrl}
          style={{
            width: "100%",
            height: "400px",
            objectFit: "cover",
            marginTop: theme.spacing(1),
          }}
          data-testid="google-map-with-locations"
        />
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionLocation;
